import { useDataChange, useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let action_id = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'id',
  })

  return function onChange(next, ...args) {
    if (!next) return
    change(inext => {
      inext[action_id] = next
    })
  }
}
